module.exports = __webpack_public_path__ + "img/curso-mobile.1fe9e243.png";